import React, { useEffect, useMemo, useState } from 'react';
import { Card } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { SalesInvoiceSearch } from '../../components/SalesInvoices/SalesInvoiceSearch';
import { SalesInvoiceEditorTabs } from '../SalesInvoiceView/SalesInvoiceEditorTabs';
import { useNavigation } from '../../../common/navigation';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { ResponseError } from '../../../common/pokCore/autogenerated/pokApiClient';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';
import useConfirmationModal from '../../../common/hooks/useConfirmationModal';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';

export const SalesInvoicesReadyToCorrection: React.FC = () => {
  const pok = usePokCore();
  const nav = useNavigation();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('fvsLng');
  const { confirm, RenderModal } = useConfirmationModal();
  const [isLoading, setIsLoading] = useState(false);
  const [symphonyHandel, setSymphonyHandel] = useState(false);

  useEffect(() => {
    pok.companies
      .getById(pok.getCompanyId())
      .then(company => setSymphonyHandel(company?.symphonyHandel ?? false))
      .catch(err => notifications.caughtError(err));
  }, [pok, notifications]);

  const createCorrection = async (id: string) => {
    try {
      const salesInvoiceNumber = await pok.salesInvoices.getNumberToCorrect(id);
      await confirm(
        t(tk.finance.alertDraftInvoiceCorrectionCreation, {
          number: salesInvoiceNumber,
        }),
      );
      setIsLoading(true);
      pok.salesInvoices
        .createCorrection(id)
        .then(data => {
          nav.salesInvoiceEditor({
            salesInvoiceId: data.id,
            tab: SalesInvoiceEditorTabs.MEDIAPLAN_POSITIONS,
            notSavedTab: SalesInvoiceEditorTabs.MEDIAPLAN_POSITIONS,
          });
        })
        .catch(async (response: ResponseError) => {
          const errors = await responseErrors(response);
          notifications.error(errors.join('. '));
        })
        .finally(() => setIsLoading(false));
    } catch {
      /* empty */
    }
  };

  const getDataInvoices = useMemo(
    () =>
      ((pageSize, pageNumber, orderBy, orderDirection, filterText) =>
        pok.salesInvoices.getAllByPortionByNegativePositionsDiff(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
        )) as GridGetterFunction,
    [pok.salesInvoices, t, tk],
  );

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          {t(tk.finance.invoicesToCorrect)}
        </Card.Title>
        <SalesInvoiceSearch
          getData={getDataInvoices}
          getCount={pok.salesInvoices.getAllCountByNegativePositionsDiff}
          onRowClick={createCorrection}
          withPayment={
            process.env.REACT_APP_SALES_INVOICES_WITH_PAYMENTS?.toLocaleLowerCase() ===
              'on' && symphonyHandel
          }
        />
      </Card.Body>
      <RenderModal size="lg" isLoading={isLoading} />
    </Card>
  );
};
